import { typography } from '@dentalux/ui-library-core'
import { createUseStyles } from 'react-jss'
import customColors from 'src/config/colorsV2'
import { forDesktopDown } from 'src/config/mediaQueries'
import { Theme } from '@mui/material/styles'

export default createUseStyles((theme: Theme) => ({
  treatmentInfoSection: {
    backgroundColor: customColors.white,
    fontFamily: 'Roboto',
    display: 'flex',
    justifyContent: 'center',
    boxShadow: '0px 1px 2px rgba(33, 33, 33, 0.1)',
    padding: '20px',
    [forDesktopDown]: {
      padding: '16px',
    },
  },
  treatmentInfoSectionContactScreen: {
    padding: '16px',
    [forDesktopDown]: {
      padding: '8px',
    },
  },
  treatmentInnerContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '550px',
    [forDesktopDown]: {
      width: '100%',
      flexDirection: 'column',
      alignItems: 'flex-start',
    },
  },
  treatmentInnerContainerContactScreen: {
    width: 480,
    flexDirection: 'column',
    [forDesktopDown]: {
      width: '100%',
      maxWidth: 375,
    },
  },
  practitionerContainer: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
  },
  practitionerDetailsFirstLine: {
    ...typography['Lato Emphasized 1'],
    marginBottom: '6px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: '340px',
  },
  removeMaxWidth: {
    maxWidth: 'unset',
  },
  practitionerDetailsSecondLine: {
    ...typography['Lato Body 2'],
  },
  practitionerAvatar: {
    display: 'flex',
    marginRight: '16px',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 0,
    gap: '8px',

    width: '48px',
    height: '48px',

    background: '#E0E0E0',
    boxShadow: '0px -0.5px 0.5px rgba(0, 0, 0, 0.1), 0px 0.5px 1px rgba(0, 0, 0, 0.35)',
    borderRadius: '100px',

    flex: 'none',
    order: 0,
    flexGrow: 0,
    backgroundSize: 'contain',
  },
  practitionerDetailsContainer: {
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
  },
  editPencilMobile: {
    flex: 1,
    display: 'flex',
    justifyContent: 'flex-end',
  },
  selectPractitionersButton: {
    whiteSpace: 'nowrap',
    [forDesktopDown]: {
      marginLeft: '64px',
    },
  },
  selectPractitionersButtonTopSpacing: {
    [forDesktopDown]: {
      marginTop: 8,
    },
  },
  appointmentSummary: {
    marginLeft: '16px',
    marginBottom: '12px',
    ...typography['Lato Emphasized 1'],
    color: theme.palette.grey['500'],
  },
}))
